import { RootState } from '../../types';

export const catalogByAlias = (state: RootState, alias: string) =>
  state.games.catalogs[alias] || { list: [], ready: false, loading: false };
